<template>
  <div class="app">
    <div class="sliced-bar">
      <div class="sliced-bar__top"></div>
      <div class="sliced-bar__middle"></div>
      <div class="sliced-bar__bottom"></div>
      <div class="sliced-bar__base">
        <h1>Header Information</h1>
        Info Goes Here
      </div>
      <!-- <div class="sliced-bar__image">
        <img src="./assets/hands.jpg" alt="">
      </div> -->
    </div>
    <div class="beside image-right">
      <div class="content__wrapper">
        <h2>Title Is For Titles And Is Title</h2>
        <h3>Byline</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto inventore saepe praesentium vel nesciunt iure voluptates a aperiam cum placeat!</p>
      </div>
      <div class="image__wrapper">
        <img src="./assets/hands.jpg" alt="">
      </div>      
    </div>
    <div class="beside image-left">
      <div class="content__wrapper">
        <h2>Title Is For Titles And Is Title</h2>
        <h3>Byline</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto inventore saepe praesentium vel nesciunt iure voluptates a aperiam cum placeat!</p>
      </div>
      <div class="image__wrapper">
        <img src="./assets/hands.jpg" alt="">
      </div>      
    </div>
    <Flipper />
  </div>
</template>

<script>
import Flipper from './components/Flipper.vue'
export default {
  name: 'app',
  components: {
    Flipper
  },
  data: function() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="sass">
  html
    box-sizing: border-box

  body 
    margin: 0 auto
    padding: 0

  .sliced-bar
    position: relative
    width: 100%
    height: 50vh
    margin: 0 auto
    display: flex
    flex-wrap: wrap
    justify-content: center

  .sliced-bar__top,
  .sliced-bar__middle,
  .sliced-bar__bottom
    position: absolute
    border-radius: 3rem;
    height: 40rem
    width: 40rem

  .sliced-bar__top
    top: 5%
    left: 20%
    z-index: -5
    background: rgba(255, 0, 0, 0.25)
    animation: clockwise 20s linear infinite

  .sliced-bar__middle
    bottom: -100%
    right: 10%
    z-index: -2
    background: rgba(0,255,0,.25)    
    animation: clockwise 6s linear infinite

  .sliced-bar__bottom
    bottom: -50%
    z-index: -3
    background: rgba(0,0,255,.25)
    animation: counter-clockwise 12s linear infinite

  .sliced-bar__base
    width: 100%
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    width: 50%

  .beside
    width: 50%
    margin: 0 auto
    display: flex
    align-items: center
    justify-content: space-around

  .content__wrapper
    display: flex
    flex-direction: column
    width: 50%

  .image-right
    flex-direction: row
    
    .content__wrapper
      align-items: flex-start
      text-align: left
      padding-right: 1rem


  .image-left
    flex-direction: row-reverse

    .content__wrapper
      align-items: flex-end
      text-align: right
      padding-left: 1rem

  .image__wrapper img 
    width: 100%
    height: auto
    display: block

  @media (max-width: 960px)
    .sliced-bar
      overflow: hidden

    .sliced-bar__top,
    .sliced-bar__middle,
    .sliced-bar__bottom
      width: 25rem
      height: 25rem

    .sliced-bar__top
      top: -20%
      left: 10%

    .sliced-bar__middle
      bottom: 0
      right: 10%

    .beside
      width: 90%
      flex-wrap: wrap

    .content__wrapper
      width: 100%

  @keyframes clockwise 
    100%
      transform: rotate(360deg)
  @keyframes counter-clockwise
    100%
      transform: rotate(-360deg)
</style>
